import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import WhyUsSection from "./components/WhyUsSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen" style={{ background: "#0a0a0a" }}>
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <WhyUsSection />
      <ContactSection />
      <Footer />
    </main>
  );
}
